import { render, staticRenderFns } from "./RatingList.vue?vue&type=template&id=0a867132"
import script from "./RatingList.vue?vue&type=script&lang=js"
export * from "./RatingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports